import { briefApi } from 'api'
import { SyncAction } from 'types/Project'

export interface Props {
  id: string
  newUhubId: string
  actionType: SyncAction
}

export const postProjectSync = ({ id, actionType, newUhubId }: Props) =>
  briefApi.post(`/projects/${id}/uhub-sync`, { action: actionType, uhubId: newUhubId })
